export default [
  {
    path: "/employee",
    name: "employee",
    component: () => import("@/views/employee/Employee.vue"),
  },
  {
    path: "/employees-salary/:id",
    name: "employees-salary",
    component: () => import("@/views/employee/EmployeesSalary.vue"),
  },
  {
    path: "/create-employees-salary",
    name: "create-employees-salary",
    component: () => import("@/views/employee/CreateSalaries.vue"),
  },
  {
    path: "/salary-actions",
    name: "salary-actions",
    component: () => import("@/views/employee/SalaryActions.vue"),
  },
  {
    path: "/employee-job-title",
    name: "employee-job-title",
    component: () => import("@/views/employee/EmployeeJobTitle.vue"),
  },
];
